import React, { useEffect, useState, useContext } from "react";
import ContentIcon from "../ContentIcon";
import { ToolBarContainer, StarList } from "./styles";
import TemplateContext from "@/context/Template/TemplateContext";
import SaveCollectionsNews from "@/shared/SaveCollectionsNews";
import ScoringTool from "../ScoringTool";
import { ReviewButton } from "./ReviewButton";
import { ReviewStars } from "./ReviewStars";
import axios from 'axios';
import { useAppTrue } from "@/hooks/index";

const ToolBarRecipes = (props) => {
  const { buttonId } = props;

  const dataContext = useContext(TemplateContext);
  const { content: formatContent, ...rest } = dataContext || {};
  const [dataReview, setDataReview] = useState();
  const [loadingReviewRecipe, setLoadingReviewRecipe] = useState(true);

  const noteDetail = {
    _id: formatContent?._id,
    url: formatContent?.url,
  };
  const isApp = useAppTrue();

  useEffect(() => {
    const saveModal1 = document.getElementById("food-card-add");
    const saveModal2 = document.getElementById("food-new-collection");
    const saveModal3 = document.getElementById("food-card-remove");
    const saveTool = document.getElementById("toolSave");
    const svgSave = document.querySelector(".btnCircle");

    if (!saveModal1 && !saveModal2 && !saveModal3) return;

    const observerSave = new MutationObserver(() => {
      const isAnyModalOpen =
        saveModal1?.classList.contains("isOpen") ||
        saveModal2?.classList.contains("isOpen") ||
        saveModal3?.classList.contains("isOpen");

      if (isAnyModalOpen) {
        svgSave?.classList.add("save-open");
        saveTool?.classList.add("save-open");
      } else {
        svgSave?.classList.remove("save-open");
        saveTool?.classList.remove("save-open");
      }

      if (saveModal1) {
        saveModal1.style.display = saveModal1.classList.contains("isOpen") ? "block" : "none";
      }
    });

    [saveModal1, saveModal2, saveModal3].forEach((modal) => {
      if (modal) observerSave.observe(modal, { attributes: true, attributeFilter: ["class"] });
    });

    return () => observerSave.disconnect();
  }, []);

  const sectionWithUnderscore = "_7_";
  const noteIdWithSection = sectionWithUnderscore+noteDetail?._id;

  useEffect(() => {
      const fetchRating = async () => {
          if (!noteDetail?._id) return;

          try {
              const response = await axios.get(
                  `${process.env.NEXT_PUBLIC_API_RECIPE_REVIEWS}/review-api/subjectsummary?externalSubjectIdList=${noteIdWithSection}`
              );

              const data = response?.data?.[0];
              setDataReview(data);
          } catch (error) {
              // console.log('Error al obtener los datos:', error);
          } finally {
              setLoadingReviewRecipe(false);
          }
      };

      fetchRating();
  }, []);

  return (
    <ToolBarContainer>
      <div className="tool qualification">
        <span>Calificación</span>
        {loadingReviewRecipe ?
          <span>. . .</span>
        :
          <ReviewStars dataReview={dataReview}/>
        }
      </div>
      <div className="tool print" onClick={formatContent.printPage}>
        <span>Imprimir</span>
        <ContentIcon className="svg-tool" width="22px" height="22px" nameIcon="print-solid" />
      </div>
      {!isApp &&
        <div id="toolSave" className="tool save">
          <span>Guardar</span>
          <SaveCollectionsNews noteDetail={noteDetail} classCustom="btn__collection--section" />
        </div>
      }
      <div className="tool score" id="score">
        <ReviewButton buttonId={buttonId} noteDetail={noteDetail} />
      </div>
      <ScoringTool />
    </ToolBarContainer>
  );
};

export default ToolBarRecipes;